export default function (role) {
  return {
    // Setting
    viewSetting: role === 'admin',
    // Staff
    viewStaffList: role === 'admin',
    viewStaffDetail: role === 'admin',
    // Customer Group List
    viewCustomerGroupList: role === 'admin',
    // Customer
    viewCustomerList: role === 'admin' || role === 'cashier',
    viewCustomerDetail: role === 'admin' || role === 'cashier',
    // Category
    viewCategoryList: role === 'admin',
    // UOM
    viewUOMList: role === 'admin',
    // Tag
    viewTagList: role === 'admin',
    // Vendor
    viewVendorList: role === 'admin',
    viewVendorForm: role === 'admin',
    // Product
    viewProductList: role === 'admin',
    viewProductForm: role === 'admin',
    // POS Register
    viewPOSRegister: role === 'admin' || role === 'cashier',
    // POS
    viewPOS: role === 'admin' || role === 'cashier',
    // POS Order
    viewPOSOrderList: role === 'admin' || role === 'cashier',
    // POS Order Detail
    viewPOSOrderDetail: role === 'admin' || role === 'cashier',
    // POS Setting List
    viewPOSSettingList: role === 'admin',
    // POS Setting Form
    viewPOSSettingForm: role === 'admin',
    // Scrap List
    viewScrapList: role === 'admin',
    // Scrap Form
    viewScrapForm: role === 'admin',
    // Inventory List
    viewInventoryList: role === 'admin',
    // Inventory Form
    viewInventoryForm: role === 'admin',
    // Tax List
    viewTaxList: role === 'admin',
    // Purchase Order List
    viewPurchaseOrderList: role === 'admin',
    // Purchase Order Detail
    viewPurchaseOrderDetail: role === 'admin',
    // Report Inventory Valuation
    viewReportInventoryValuation: role === 'admin',
    // Specialization
    viewSpecializationList: role === 'admin',
    // Prescription Template
    viewPrescriptionTemplateList: role === 'admin',
  };
}
